import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

export const report = async (query) => {
  const response = await apiClient.request('GET', `/admin/report${query}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name reportDeleteById
 * @param {string | number} id
 * @response success - 204 No Content
 * @response failure - 404 Not Found
 */
export const reportDeleteById = async (id) => {
  const response = await apiClient.request('DELETE', `/admin/report/${id}`);
  if (!isApiResponseError(response)) {
    return true;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name reportDeleteByIds
 * @param {Array.<string | number>} ids
 * @response success - 204 No Content
 * @response failure - 404 Not Found
 */
export const reportDeleteByIds = async (ids) => {
  const response = await apiClient.request('DELETE', '/admin/report', ids);
  if (!isApiResponseError(response)) {
    return true;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name reportExport
 * @param {*} data
 * @param {*} export_type
 * @response success - 200 OK
 * @response failure - 404 Not Found
 */
export const reportExport = async (data, export_type, lang) => {
  apiClient.setCustomHeader('lang', lang ?? 'ja');

  const response = await apiClient.request('POST', `/admin/report/export?export_type=${export_type}`, data, {
    responseType: 'blob',
  });
  if (!isApiResponseError(response)) {
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'survey_export.zip';
    if (contentDisposition) {
      /* eslint-disable */
      const utf8Match = contentDisposition.split("filename*=utf-8''");
      if (utf8Match.length > 1) {
        filename = decodeURIComponent(utf8Match[1]);
      } else {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch !== null && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }
      /* eslint-enable */
    }

    const blob = response?.data;
    const url = window.URL.createObjectURL(new Blob([blob], { type: blob.type }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    apiClient.resetHeader();
  } else {
    apiClient.resetHeader();
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name reportDetail
 * @param {string | number} id
 * @response success - 200 OK
 * @response failure - 404 Not Found
 */
export const reportDetail = async (id) => {
  const response = await apiClient.request('GET', `/admin/report/${id}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
